// Convert bikes images from qwic.nl to thumbnail size
export const convertImageToThumbnail = (qwicImageUrl: string) => {
    return qwicImageUrl.replace('.png', '-400x275.png');
};

// Convert bikes images from qwic.nl to large size
export const convertImageToLarge = (qwicImageUrl: string) => {
    return qwicImageUrl.replace('.png', '-1140x784.png')
}
